/* eslint-disable camelcase */
import httpConf from '@shared/h5/utils/request/conf';
import request from '@shared/h5/utils/request-new';

export interface Company {
  name: string;
  clogo: string;
  people: string;
  stage: string;
  domain: string;
  intro: string;
  follower_cnt: number;
  recent_job_cnt: number;
  employee_cnt: number;
  title: string;
  keywords: string;
  description: string;
}

export interface CompanyInfo {
  name: string;
  share_url: string;
  logo: string;
  clogo: string;
}

export interface WorkExp {
  company_info: CompanyInfo;
  company: string;
  ekey?: string;
  tags: string[];
  position: string;
  start_date: string;
  start_month: number;
  start: number;
  end_date?: string;
  end_month?: number;
  end?: number;
}

export interface Contact {
  id: number;
  name: string;
  avatar: string;
  company: string;
  position: string;
  judge: number;
  position_judge: number;
  mem_id: number;
  rank: number;
  city: string;
  loc: string;
  province: string;
  visit_cnt: number;
  tags: string[];
  headline: string;
  work_exp: WorkExp[];
  trackable_token: string;
}

export interface ExtData {
  ekey: string;
  text: string;
}

export interface OriginContacts {
  realname: string;
  gender: number;
  company: string;
  avatar: string;
  mem_st: number;
  judge: number;
  position: string;
}

export interface DataResponse {
  others?: ExtData[];
  cooperation: Company;
  contacts: Contact[];
  origin_contacts?: OriginContacts;
  rec_contacts: Contact[];
  result: string;
}

export interface DataByClientResponse {
  list: Contact[];
  result: string;
}

export interface ResponseError {
  error_code: number;
  error_msg: string;
  result: string;
}

const isProd = process.env.NODE_ENV === 'production';

export async function fetchDataByClient(ekey: string, page: number | string = 0, count: number | string = 5) {
  return request
    .get<DataByClientResponse>('/sdk/seo/mid_page_info', {
      baseURL: isProd ? httpConf.node_host : null,
      // 跨域携带cookie
      credentials: 'include',
      params: {
        ekey,
        page,
        count,
      },
    })
    .then((res) => res.data);
}

export default function fetchData(
  ekey: string,
  u: string,
  token: string,
  page: number | string = 0,
  count: number | string = 10
) {
  return request.get<DataResponse>(`/search/seo/mid_page_info`, {
    baseURL: httpConf.online_host,
    params: {
      ekey,
      u,
      access_token: token,
      page,
      count,
    },
  });
}

export interface HotArticleResponse {
  articles: Article[];
  highlight_words?: any;
  remain: number;
  result: string;
  total: number;
}

export interface Article {
  efid: string;
  id: number;
  score: number;
  summary: string;
  title: string;
  title_raw: string;
}

export function getHotArticle() {
  return request
    .get<HotArticleResponse>(`/search/headline`, {
      baseURL: httpConf.online_host,
      params: {
        uid: 6,
        sid: 1,
        frm: 'article',
      },
    })
    .then((res) => res.data);
}
